import React, { Component } from 'react';
import Placeholder from '../../assets/images/PageVisual.svg';

export default class TeamMember extends Component {
  render() {
    // console.log(this.props);
    const image = this.props.image;
    const name = this.props.name;
    const department = this.props.department;
    const email = this.props.email;
    const phone = this.props.phone;

    return (
      <div className="team-member swiper-slide">
        {image ? (
          <div className="member-image swiper-lazy" data-background={image}>
            <div className="swiper-lazy-preloader" />
          </div>
        ) : (
          <div
            className="member-image member-image-empty flex flex-center swiper-lazy"
            data-background={Placeholder}>
            <div className="swiper-lazy-preloader" />
            Geen afbeelding beschikbaar
          </div>
        )}
        {name && <h4 className="member-name mt15">{this.props.name}</h4>}
        {department && (
          <span className="member-department">{this.props.department}</span>
        )}
        {email && (
          <a className="member-mail" href={'mailto:' + this.props.email}>
            {this.props.email}
          </a>
        )}
        {phone && <span className="member-phone">{this.props.phone}</span>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TeamMember/TeamMember.jsx